import { setupFileUpload } from "../util/upload";

/**
 * ランニング注文ページ用のスクリプト
 */
if (is_route('running_order.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        running_order_event_set();
        running_order_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.running_order_event_set = function () {

    // 設定表示
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id']);
    });

    // 設定保存
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function (results) {
        }, function () {
        });
    });

    // リスト更新
    $(document).on('click', '[data-update_list]', function () {
        let action = $(this).data('action');
        let month = $('#search-form-month').attr('value');
        _ajax.post(action, { 'month': month }, function (results) {
            load_contents();
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
    });

    // メール詳細
    $(document).on('click', '[data-mail-detail-modal]', function () {
        _modal.create(this, 'mail-detail-modal', ['month', 'end_holding_id',  'index']);
    });

    // メール編集
    $(document).on('click', '[data-mail-setting-modal]', function () {
        _modal.create(this, 'mail-setting-modal', ['month', 'end_holding_id']);
    });

    // メール送信
    $(document).on('click', '[data-mail-send]', function () {
        _modal.submit(this, 'mail-send', function (results) {
        }, function (xhr, status, errorThrown) {
        });
    });

    // メール編集画面用スクリプト読込
    require('../util/mail');

    // 注文書データアップロード
    let month = $('#search-form-month').attr('value');
    const appendDataForConfirm = function (data) {
        data.append('month', month);
    }
    const appendDataForSave = function (data) {
        data.append('month', month);
    }
    setupFileUpload([{
        fileName: 'upload_file',
        appendDataForConfirm: appendDataForConfirm,
        appendDataForSave: appendDataForSave
    }]);
    $(document).on('click', '[data-upload-modal]', function () {
        _modal.create(this, 'upload-modal', [], false);
    });

    // エリア（複数可）絞り込み決まるとき
    $(document).on('click', '#running_order-submit_area', function () {
        load_contents(null, false);
    });
    /**
     * 設定モーダル表示時のイベント設定
     * @uses ダッシュボードからモーダル表示する際にも呼び出される
     */
    window.running_order_setting_event_set = function () {

    }
}
